"use client";

import { isNativeApp } from "@/lib/nativePlatform";

export async function getNativeDeviceMetadata() {
  if (typeof window === "undefined") return null;
  if (!isNativeApp()) return null;

  try {
    const [{ App }, { Device }] = await Promise.all([
      import("@capacitor/app"),
      import("@capacitor/device"),
    ]);
    const [appInfo, deviceInfo, deviceId] = await Promise.all([
      App.getInfo().catch(() => null),
      Device.getInfo().catch(() => null),
      Device.getId().catch(() => null),
    ]);

    const appId = appInfo?.id || "";
    const platform = deviceInfo?.platform || "";
    const model = deviceInfo?.model || "";
    const osVersion = deviceInfo?.osVersion || "";

    return {
      appId,
      bundleId: appId,
      packageName: appId,
      appVersion: appInfo?.version || "",
      buildNumber: appInfo?.build || "",
      platform,
      deviceModel: model,
      model,
      osVersion,
      operatingSystem: deviceInfo?.operatingSystem || "",
      osName: deviceInfo?.operatingSystem || platform,
      manufacturer: deviceInfo?.manufacturer || "",
      nativeInstallId: deviceId?.identifier || "",
      isVirtual: Boolean(deviceInfo?.isVirtual),
      webViewVersion: deviceInfo?.webViewVersion || "",
    };
  } catch {
    return null;
  }
}
